export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://vapor.api.vepaar.com/graphql/open", "tokenStorage": "cookie", "tokenName": "vp-store-token", "httpLinkOptions": {"credentials": "include"}, "authType": "Bearer", "authHeader": "Authorization", "defaultOptions": undefined}}
}